import { Action } from '@ngrx/store';

export function getStopLoadingType<TModel>(module: string, type: { new(): TModel; }): string {
  return `[${module}] Stop Loading for ${(type as any).$typeName}`;
}

export class StopLoadingAction<TModel> implements Action {
  readonly type: string;

  constructor(module: string, modelType: { new(): TModel; }) {
    this.type = getStopLoadingType(module, modelType);
  }
}



// WEBPACK FOOTER //
// ./src/app/pillar/dashboard/store/actions/StopLoadingAction.ts